import { render, staticRenderFns } from "./SvgWebsite.vue?vue&type=template&id=67156ab2&scoped=true&"
import script from "./SvgWebsite.vue?vue&type=script&lang=js&"
export * from "./SvgWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67156ab2",
  null
  
)

export default component.exports